module.exports = __webpack_public_path__ + "img/nc.dfbc2084.svg";